<template>
  
     <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="orgForm">
      <el-form-item label="公证视频上传" prop="videoUrl">
        <el-upload
          class="avatar-uploader"
          action="#"
          name="file"
          ref="upload"
          accept="video/*"
          :on-change="onChange"
          :http-request="upLoadFile"
          :auto-upload="false"
          :on-remove="handleRemove"
          :file-list="fileList"
          :multiple="false"
          :limit="1"
          >
          <el-button size="small" type="primary" :disabled="fileList.length>0">点击上传</el-button>
        </el-upload>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" :loading="loading" @click="submitForm('ruleForm')">确认提交视频</el-button>
      </el-form-item>
     </el-form>

</template>

<script>
export default {
  props: {
    notaryId: {
      type: Number | null | String,
      required: true
    },
    videoId: {
      type: Number | null | String,
      required: true
    },

  },
  data() {
    return {
      visible: false,
      ruleForm: {
        videoUrl: ''
      },
      rules: {
        videoUrl: [
          { required: true, validator: (rule, value, callback) => {
            if (this.fileList.length === 0) {
              callback(new Error('请上传公证视频！'));
            } else {
              callback();
            }
          }, trigger: 'change' },
        ],
      },
      fileList: [],
      loading: false
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.fileList.length === 0) {
            this.$message.error('请上传公证视频！')
            return;
          }
          this.$refs.upload.submit();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    // 移除文件
    handleRemove(file, fileList) {
      this.fileList = fileList;
      console.log(fileList);
    },
    // 改变文件
    onChange(file,fileList) {
      this.fileList = fileList;
      console.log(fileList);
    },
    // 上传到文件服务器
    upLoadFile(data) {
      this.loading = true;
      let param = new FormData();
      param.append('file', data.file);
      this.$api.upLoadFile(param).then(res => {
        if (res.data.code === '200') {
          this.ruleForm.videoUrl = res.data.data.urf;
          this.submit();
        } else {
          this.$message.error('视频上传失败！');
        }
      }).catch(error => {
        this.loading = false;
      })
    },
    // 通过审核
    submit() {
      this.loading = true;
      let reqData = {
        notaryId: this.notaryId,
        url: this.ruleForm.videoUrl
      }
      if (this.videoId) {
        reqData.id = this.videoId
      }
      this.$api.saveOrUpdateVideo(reqData).then(res => {
        this.$successCallback(res, '提交成功',() => {
          this.$emit('sumitSuccess');
        })
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>
<style scoped>
.el-form-item {
  margin-bottom: 12px;
}
</style>